var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5535 24.4725C44.5535 23.09 44.431 21.7775 44.221 20.5H24.446V28.3925H35.7685C35.261 30.9825 33.7735 33.17 31.5685 34.6575V39.9075H38.3235C42.2785 36.25 44.5535 30.86 44.5535 24.4725Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4461 45.0001C30.1161 45.0001 34.8586 43.1101 38.3236 39.9076L31.5686 34.6576C29.6786 35.9176 27.2811 36.6876 24.4461 36.6876C18.9686 36.6876 14.3311 32.9951 12.6686 28.0076H5.70361V33.4151C9.15111 40.2751 16.2386 45.0001 24.4461 45.0001Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6685 28.0075C12.231 26.7475 12.0035 25.4 12.0035 24C12.0035 22.6 12.2485 21.2525 12.6685 19.9925V14.585H5.70354C4.26854 17.42 3.44604 20.605 3.44604 24C3.44604 27.395 4.26854 30.58 5.70354 33.415L12.6685 28.0075Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4461 11.3125C27.5436 11.3125 30.3086 12.38 32.4961 14.4625L38.4811 8.4775C34.8586 5.0825 30.1161 3 24.4461 3C16.2386 3 9.15111 7.725 5.70361 14.585L12.6686 19.9925C14.3311 15.005 18.9686 11.3125 24.4461 11.3125Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.6c0aaa7e6bace88959c5b41404f493fd.svg";
export { ForwardRef as ReactComponent };